// Needed to get proper type of key when using Object.entries()
type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

export const getTypedEntries = <T extends object>(obj?: T) => (obj ? Object.entries(obj) : []) as Entries<T>;

export const getTypedKeys = <T extends object>(obj: T) => Object.keys(obj) as (keyof T)[];
